import { createState } from "@persevie/statemanjs";

export const logoUrlState = createState("static/media/logo-sp.svg");
export const isShowIgnoredFilesModalState = createState(false);
